module.exports = __webpack_public_path__ + "static/img/13.a97ab5a2.jpg";